import { useEffect, useState, Dispatch, SetStateAction, ReactElement } from "react";
import {Input, TrashCanIcon, AddIcon, ExclamationCircleIcon, Loader } from "@fluentui/react-northstar";
import { verifyCallGroupParticipant } from "../../apis/cyberGateManagementApi/cyberGateApiClient";
import { useDebounce } from "../../hooks/useDebounce";
import { NewTeamUser } from "./Types";

interface InputInEditModeProps {
    userName: string;
    index: number;
    isValid: boolean;
    isBackValid: boolean;
    inputTheme: string;
    groupId: string;
    setNewUsers: Dispatch<SetStateAction<NewTeamUser[]>>;
    createTooltip: (userNameValid: boolean, backendValid: boolean, Component: ReactElement) => ReactElement;
    deleteNewUsers: (index: number) => void;
    handleFormChange: (index: number, value: string) => void;
  }

export const InputInEditMode = ({ userName, deleteNewUsers, index, handleFormChange, isBackValid, isValid, groupId, inputTheme, setNewUsers, createTooltip }: InputInEditModeProps) => {
    const [focus, setFocus] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const debounced = useDebounce(userName, 350);
  
    useEffect(() => {
      if (isValid && focus) {
        setLoading(true)
        validateUserFromBackend()
        verifyCallGroupParticipant(groupId, userName).then(({ teamsUserNameValid }) => {
          setLoading(false)
          validateUserFromBackend(teamsUserNameValid)
        })
      }
      if (!isValid && focus) {
        validateUserFromBackend()
      }
  
    }, [debounced])
  
    const validateUserFromBackend = (value: boolean = false) => {
      setNewUsers(users => {
        const newUsers = [...users]
        newUsers[index].isBackValid = value
        return newUsers
      });
    }
  
    const warningValidateTooltip = createTooltip(isValid, isBackValid, <ExclamationCircleIcon styles={{ color: 'red', marginRight: 10 }} />)
  
    return (
      <div style={{backgroundColor: inputTheme}} className="new-team-users">
        {userName && <AddIcon size="small" styles={{ color: 'grey', marginLeft: 10 }} />}
        <Input
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          value={userName}
          disabled={loading}
          onChange={(e) => handleFormChange(index, (e.target as HTMLInputElement).value)}
          variables={{ backgroundColor: inputTheme, borderRadius: 'none', borderColor: 'transparent' }}
          fluid
          icon={!loading ? 
          <> 
          {(!isValid || !isBackValid) || !userName ? warningValidateTooltip : null} 
          <TrashCanIcon outline className="edit-del-icon" onClick={() => deleteNewUsers(index)} />
          </> : 
          <Loader size="smallest"/>}
          placeholder="Add Teams username..." />
      </div>
    )
  }